/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { createContext, useContext, useMemo, useState } from 'react';
import FormRenderer, { FormRendererProps } from '@data-driven-forms/react-form-renderer/dist/cjs/form-renderer';
import { componentsMapper, FormTemplate, plainTextMapper, validatorMapper } from '../components/ddf';
import { ValidatorMapper } from '@data-driven-forms/react-form-renderer/dist/cjs/validator-mapper';

const DdfContext = createContext<{
  handlers: Record<string, (...args: any[]) => void>;
  optionalValues?: { [val: string]: boolean };
  isInModal?: boolean;
  noFooterBtns?: boolean;
  readOnly?: boolean;
  groupType?: string;
  footerOverrides?: any;
  subForm: string | null;
  setSubForm: (string) => void;
  loading: boolean;
}>({
  handlers: {},
  setSubForm: () => {},
  subForm: null,
  loading: false
});

interface FormRendererPropsHandlers extends Partial<FormRendererProps> {
  onSubmit: FormRendererProps['onSubmit'];
  schema: FormRendererProps['schema'];
  handlersMapper: Record<string, (...args: any[]) => void>;
  isInModal?: boolean;
  noFooterBtns?: boolean;
  groupType?: string;
  readOnly?: boolean;
  FormTemplate?: any;
  footerOverrides?: any;
  loading: boolean;
}

export function FormRendererWithHandlers({
  handlersMapper,
  optionalValues,
  isInModal,
  noFooterBtns,
  readOnly,
  footerOverrides,
  groupType,
  loading,
  ...formRendererProps
}: FormRendererPropsHandlers) {
  const [subForm, setSubForm] = useState<string | null>(null);

  const contextValue = useMemo(
    () => ({
      handlers: handlersMapper,
      optionalValues,
      isInModal,
      noFooterBtns,
      readOnly,
      groupType,
      footerOverrides,
      subForm,
      setSubForm,
      loading
    }),
    [footerOverrides, groupType, handlersMapper, isInModal, loading, noFooterBtns, optionalValues, readOnly, subForm]
  );

  return (
    <DdfContext.Provider value={contextValue}>
      <FormRenderer
        componentMapper={readOnly ? plainTextMapper : componentsMapper}
        FormTemplate={FormTemplate}
        validatorMapper={validatorMapper as ValidatorMapper}
        {...formRendererProps}
      />
    </DdfContext.Provider>
  );
}

export function useDdf() {
  return useContext(DdfContext);
}
